import type { RootState } from "store";

export const selectDrawingInstances = (state: RootState) => state.drawing.instances;
export const selectDrawingCount = (state: RootState) => state.drawing.instances.length;
export const selectChartPriceRange = (state: RootState) => state.drawing.chartPriceRange;

export const selectHorizontalLineInitialPrice = (state: RootState): number | null => {
  const range = state.drawing.chartPriceRange;
  if (!range) return null;
  return (range.min + range.max) / 2;
};

export const selectVerticalLineInitialTimestamp = (state: RootState) =>
  state.drawing.verticalLineInitialTimestamp;
